// extracted by mini-css-extract-plugin
module.exports = {"cashButtons":"CashManagement_cashButtons__-BjFj"};